import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { BookmarkPlanState } from "./Bookmark";

const SLICE = "Bookmark";

const initialState: BookmarkPlanState = {
  list: [],
  status: "idle",
  totalRecords: 0,
  bookmarkedPlansList: [],
  bookmarkShowLoader: false
};

export const fetchBookmarkPlansIdAsync = createAsyncThunk(`${SLICE}/bookmarkedPlans`, (thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.getBookmarks, {}, thunkApi)
);

export const fetchBookmarkPlansAsync = createAsyncThunk(`${SLICE}/fetchbookmarkedPlans`, (data: {}, thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.postPlans, data, thunkApi)
);

export const bookmarkPlan = createAsyncThunk(`${SLICE}/createBookmark`, (data: {}, thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.postBookmarks, data, thunkApi)
);

export const removeBookmarkPlan = createAsyncThunk(`${SLICE}/removebookmarkedPlan`, (data: {}, thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.deleteBookmarks, data, thunkApi)
);

export const BookmarkedPlanSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    removeBookmarkedPlan(state, action) {
      const bookmarkPlans = state.bookmarkedPlansList.filter((plan) => plan.id !== action.payload);
      state.bookmarkedPlansList = bookmarkPlans;
    },
    setBookmarkedPlanList(state) {
      state.bookmarkedPlansList = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookmarkPlansIdAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBookmarkPlansIdAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.list = action.payload.bookmarkedPlans;
      })
      .addCase(fetchBookmarkPlansIdAsync.rejected, (state) => {
        state.status = "idle";
        state.list = [];
      })
      .addCase(fetchBookmarkPlansAsync.pending, (state, action: any) => {
        state.bookmarkShowLoader = action.meta.arg.pagination.page === 1;
        state.status = action.meta.arg.pagination.page === 1 ? "loading" : "idle";
      })
      .addCase(fetchBookmarkPlansAsync.fulfilled, (state, action: any) => {
        state.bookmarkShowLoader = false;
        state.status = "idle";
        state.totalRecords = action.payload.meta?.page?.total;
        //below line is used to eliminate deadline date if exist in case of CORP inncode.
        const filteredPlans =
          action.meta.arg.filter?.innCode === DEFAULT_CORP_INNCODE
            ? action.payload?.plans?.map((item: any) => {
                return { ...item, brandDeadlines: [] };
              })
            : action.payload.plans;
        state.bookmarkedPlansList =
          action.meta.arg.pagination.page === 1 ? filteredPlans : [...state.bookmarkedPlansList, ...filteredPlans];
      })
      .addCase(fetchBookmarkPlansAsync.rejected, (state) => {
        state.status = "failed";

        state.bookmarkShowLoader = false;
        state.bookmarkedPlansList = [];
      });
  }
});

export const { removeBookmarkedPlan, setBookmarkedPlanList } = BookmarkedPlanSlice.actions;

export default BookmarkedPlanSlice.reducer;
